import React from 'react';
import { TRUSTPILOT_REVIEWS, BRAND } from '../../data/mock';
import { Button } from '../ui/button';
import { Star, ExternalLink, Award, Quote } from 'lucide-react';

export const TrustpilotReviews = () => {
  return (
    <section className="py-20 md:py-28 bg-gradient-to-b from-white to-emerald-50/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header with Trustpilot Badge */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          {/* #1 Trustpilot Badge */}
          <div className="inline-flex items-center gap-3 bg-gradient-to-r from-emerald-600 to-teal-600 text-white rounded-full px-6 py-3 mb-6 shadow-lg shadow-emerald-500/30">
            <Award className="w-6 h-6" />
            <span className="font-bold text-lg">#1 Rated on Trustpilot</span>
            <div className="flex items-center gap-1 bg-white/20 rounded-full px-3 py-1">
              <Star className="w-4 h-4 fill-amber-400 text-amber-400" />
              <span className="font-bold">{TRUSTPILOT_REVIEWS.rating}</span>
            </div>
          </div>
          
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
            {TRUSTPILOT_REVIEWS.title}
          </h2>
          <p className="text-lg text-slate-600">
            {TRUSTPILOT_REVIEWS.subtitle}
          </p>
          
          {/* Trustpilot Stats */}
          <div className="flex items-center justify-center gap-6 mt-8">
            <div className="flex items-center gap-2">
              <div className="flex -space-x-1">
                {[1, 2, 3, 4, 5].map((i) => (
                  <Star key={i} className="w-6 h-6 text-emerald-500 fill-emerald-500" />
                ))}
              </div>
              <span className="text-2xl font-bold text-slate-800">{TRUSTPILOT_REVIEWS.rating}</span>
            </div>
            <div className="h-8 w-px bg-slate-200" />
            <div className="text-slate-600">
              <span className="font-bold text-slate-800">{TRUSTPILOT_REVIEWS.totalReviews}</span> verified reviews
            </div>
          </div>
        </div>

        {/* Reviews Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {TRUSTPILOT_REVIEWS.reviews.map((review, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100 hover:shadow-lg hover:border-emerald-200 transition-all duration-300 group relative overflow-hidden"
            >
              {/* Quote decoration */}
              <div className="absolute top-4 right-4 opacity-10 group-hover:opacity-20 transition-opacity">
                <Quote className="w-12 h-12 text-emerald-500" />
              </div>
              
              <div className="relative">
                {/* Rating */}
                <div className="flex items-center gap-1 mb-3">
                  {[...Array(review.rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 text-emerald-500 fill-emerald-500" />
                  ))}
                </div>
                
                {/* Title */}
                <h4 className="font-bold text-slate-800 mb-2">{review.title}</h4>
                
                {/* Review text */}
                <p className="text-slate-600 text-sm leading-relaxed mb-4">
                  "{review.text}"
                </p>
                
                {/* Reviewer info */}
                <div className="flex items-center justify-between pt-4 border-t border-slate-100">
                  <div>
                    <p className="font-semibold text-slate-800">{review.name}</p>
                    <p className="text-sm text-slate-500">{review.location}</p>
                  </div>
                  <span className="text-xs text-slate-400">{review.date}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA to Trustpilot */}
        <div className="text-center">
          <p className="text-slate-600 mb-4">Read more reviews from verified pet parents</p>
          <Button
            asChild
            size="lg"
            className="bg-emerald-600 hover:bg-emerald-700 text-white font-semibold shadow-lg shadow-emerald-500/25"
          >
            <a href={TRUSTPILOT_REVIEWS.trustpilotUrl} target="_blank" rel="noopener noreferrer">
              <Star className="w-5 h-5 mr-2 fill-current" />
              See All Reviews on Trustpilot
              <ExternalLink className="w-4 h-4 ml-2" />
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
};
